import styles from '../../styles/NavBar.module.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import logo from "../../assets/logo.png";
import { Link } from 'react-router-dom';
import NavProductCategories from './DropdownMenu';
import SearchBox from './SearchBox';
import LoggedUser from './LoggedUser';
import NavCart from './NavCart';
import { User } from '../../models/user';
import { Group1Schema } from '../../models/Group1Items';
import { Group2Schema } from '../../models/Group2Items';

interface NavBarProps {
    loggedInUser: User | null,
    onLogoutSuccessful: () => void,
    group1: Group1Schema[],
    group2: Group2Schema[],
}

const NavBar = ({loggedInUser, onLogoutSuccessful, group1, group2}:NavBarProps) => {

    return (
        <>
            <Navbar expand="lg" variant="dark" sticky="top" className={`mb-0 bg-dark px-3 py-2`}>
                <Navbar.Brand as={Link} to="/" className='me-auto'>
                    <img
                    alt=""
                    src={logo}
                    width="30"
                    height="auto"
                    className={`${styles.navbarlogo} bg-white align-top `}
                    />{' '}
                    Locs - Προϊόντα
                </Navbar.Brand>
                
                    {loggedInUser
                    && <>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto me-auto order-1 order-sm-1 justify-content-right">
                            <NavProductCategories menuData={group1} submenuData={group2} />
                            </Nav>
                        <NavCart/>
                        <SearchBox loggedInUser={loggedInUser} group1={group1} group2={group2} />
                        <LoggedUser user={loggedInUser} onLogoutSuccessful={onLogoutSuccessful} loggedInUser={loggedInUser}/>
                        </Navbar.Collapse>
                    </>
                    }
            </Navbar>

        </>
    );
}
export default NavBar;